export enum LOCKED_UNTIL_MODE {
    inherit = 'inherit',
    date = 'date',
    indefinite = 'indefinite',
}
